import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input() message: string = '';
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';
  @Input() duration: number = 3000;
  @Input() position: 'top' | 'bottom' = 'top';
  @Output() closed = new EventEmitter<void>();

  isVisible: boolean = true;
  private timeoutId: any;
  private remainingTime: number = 0;

  get iconClass(): string {
    switch (this.type) {
      case 'success':
        return 'bi-check-circle';
      case 'error':
        return 'bi-x-circle';
      case 'warning':
        return 'bi-exclamation-triangle';
      case 'info':
        return 'bi-info-circle';
      default:
        return 'bi-info-circle';
    }
  }

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  startTimer() {
    if (this.duration > 0) {
      this.remainingTime = this.duration;
      this.timeoutId = setTimeout(() => {
        this.close();
      }, this.duration);
    }
  }

  pauseTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.remainingTime -= Date.now() % this.duration;
    }
  }

  resumeTimer() {
    if (this.remainingTime > 0) {
      this.timeoutId = setTimeout(() => {
        this.close();
      }, this.remainingTime);
    }
  }

  clearTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  close() {
    this.isVisible = false;
    this.clearTimer();
    this.closed.emit();
  }
}